import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link, Outlet, useNavigate, useParams } from "react-router-dom";
import { FaHome, FaCog } from "react-icons/fa";
import LanguageToggle from "./LanguageToggle";
import Footer from "./Footer";

const Layout = () => {
  const { t, i18n } = useTranslation();
  const { lang } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (i18n.hasResourceBundle(lang, "translation")) {
      i18n.changeLanguage(lang);
    } else {
      navigate(`/${i18n.options.fallbackLng}`, { replace: true });
    }
  }, [lang, i18n, navigate]);

  return (
    <div className="flex flex-col min-h-screen bg-gradient-to-r from-start to-end bg-gradient-radial">
      <nav className="bg-primary-default">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <div className="flex items-center">
              <Link
                to="/"
                className="flex-shrink-0 text-white flex items-center space-x-1"
              >
                <FaHome className="w-6 h-6" />
                <span className="text-xl font-semibold">
                  {t("portal-name")}
                </span>
              </Link>
            </div>
            {/* Add settings icon or other navigation elements here */}
            <div className="flex items-center space-x-4">
              <LanguageToggle />
              <div className="bg-secondary-default rounded-full p-1 hover:bg-secondary-hover">
                <FaCog className="w-6 h-6 cursor-pointer text-white" />
              </div>
            </div>
          </div>
        </div>
      </nav>
      <main className="flex-1 py-20">
        <div className="max-w-7xl mx-auto sm:px-6 lg:px-8">
          <div className="p-6 max-w-screen-xl mx-auto overflow-auto">
            <Outlet />
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
